import React, { useState } from "react";
import { functions } from "../../../firebase";
import { Button } from "../../../design/button";
import { Supervisor } from "@visitproof/types";
import {
  Alert,
  AlertActions,
  AlertBody,
  AlertTitle,
} from "../../../design/alert";
import { httpsCallable } from "firebase/functions";

interface Props {
  supervisor: Supervisor;
}

const DeactivateButton: React.FC<Props> = ({ supervisor }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      const deactivateSupervisor = httpsCallable(
        functions,
        "deactivateSupervisor",
      );
      const { data } = await deactivateSupervisor({
        supervisorId: supervisor.id,
      });
      console.log(data);
      setIsOpen(false);
    } catch (error) {
      alert("Failed to upload file. Please try again later.");
    }
    setIsSubmitting(false);
  };

  const clearForm = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Button color="red" type="button" onClick={() => setIsOpen(true)}>
        Deactivate
      </Button>
      <Alert open={isOpen} onClose={setIsOpen}>
        <AlertTitle>Deactivate Monitor</AlertTitle>
        <AlertBody>
          Are you sure you want to deactivate this supervisor?
        </AlertBody>
        <AlertActions>
          <Button plain onClick={clearForm}>
            Cancel
          </Button>
          <Button color="red" disabled={isSubmitting} onClick={handleSubmit}>
            {isSubmitting ? "Deactivating..." : "Deactivate"}
          </Button>
        </AlertActions>
      </Alert>
    </>
  );
};

export default DeactivateButton;
